import { Component, OnInit, ViewChild, ElementRef, Inject, AfterViewInit, enableProdMode } from '@angular/core';
import { FirestoreService } from 'src/app/services/firebase/firestore.service';
import { CloudfunctionsService } from 'src/app/services/firebase/cloudfunctions.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import {Sort, MatSort} from '@angular/material/sort';
import Swal from 'sweetalert2';
import { colorSets } from '@swimlane/ngx-charts';
declare var $: any;

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit, AfterViewInit {

  user:any;

  companyId:any;

  urlImg:any = "../../../assets/img/images.jpeg";

  //'id',
  //'email',
  displayedColumns: string[] = [  'firstname', 'lastname', 'identification',  'phone', 'role',  'status', 'imageUrl', 'actions'];

  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;


  constructor(private afs: FirestoreService){}

  ngOnInit() {

        this.user = this.afs.usersShow;

        this.companyId = this.user.companyId;



        this.afs.getAllUsersByCompany(this.companyId).subscribe(users => {

              this.dataSource.data = users;
        });
  }

  ngAfterViewInit(){
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }



  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  sortData(sort: Sort) {
    //const data = ELEMENT_DATA.slice();
    if (!sort.active || sort.direction === '') {
      //this.sortedData = data;
      return;
    }

 }

 newUser(){
    console.log("New User");
 }

  editUser(user){

    console.log(user);
      this.user = user;
  }

  deleteUser(user){
    //console.log(user);

    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.afs
          .getCompanyPro(this.companyId)
          .then((res) => {
            let data = {};
            let locationData = res.data();

            delete locationData.employees[user.id];

            console.log(this.companyId);

            console.log(locationData.employees);

            this.afs
              .deleteUser(user.id)
              .then((resp: any) => {
                  Swal.fire('Good job!', 'User ha been deleted', 'success');
                this.afs
                  .updateCompanyNew(this.companyId, locationData)
                  .then((res) => {
                    console.log(res);
                  });
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    })




  }

  statusUser(status){
    if(status == 0){
        return "Inactive";
    }else if(status == 1){
      return "Active";
    }
   }

   typeUser(role){
    if(role == 1){
      return "Admin";
    }else if(role == 3){
       return "Driver";
    }else if(role == 2){
      return "User";
    }
   }

   getColorStatus(status){

    if(status == 0){
        return '#e74c3c'
    }else if(status ==1){
       return '#2980b9'
    }else if(status == 2){
       return '#2ecc71'
    }
  }

  getColorRole(status){

     if(status ==1){
       return '#2C3A47'
    }else if(status == 3){
       return '#218c74'
    }
  }


 }
